import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import * as openpgp from "openpgp";
import { environment } from "src/environments/environment";

export async function encryptData(PayMessage) {
  const key = environment.key;
  let pubk = await openpgp.key.readArmored(key);
  pubk = pubk.keys[0];

  const options = {
    message: openpgp.message.fromText(JSON.stringify(PayMessage)),
    publicKeys: pubk,
  };
  let ecnrypted = await openpgp.encrypt(options);
  let value = await { encryptedRequest: ecnrypted.data };
  return value;
}

export async function decryptData(msg) {
  const pkey = environment.pkey;
  let privateKey = await openpgp.key.readArmored(pkey);
  privateKey = privateKey.keys[0];
  await privateKey.decrypt("tdi-dev");
  const options = {
    message: await openpgp.message.readArmored(msg),
    privateKeys: [privateKey],
  };
  let decryptedData = await openpgp.decrypt(options);
  return decryptedData.data;
}

// takes the form field value and returns true on valid number
function validate_credit_card(value) {
  // accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(value)) return false;

  let nCheck = 0,
    nDigit = 0,
    bEven = false;
  value = value.toString().replace(/\D/g, "");

  for (let n = value.length - 1; n >= 0; n--) {
    let cDigit = value.charAt(n),
      nDigit = parseInt(cDigit, 10);

    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9;
    }

    nCheck += nDigit;
    bEven = !bEven;
  }

  return nCheck % 10 == 0;
}

export function customCreditCardValidatorValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let value = control.value;

    if (!value) {
      return null;
    }
    let isPanValid = validate_credit_card(value);
    return { isPanValid: isPanValid };
  };
}
